import React from "react";

const COLORS = {
  hot: { bg: "#fee2e2", color: "#dc2626" },
  high: { bg: "#ffedd5", color: "#ea580c" },
  medium: { bg: "#fef9c3", color: "#ca8a04" },
  low: { bg: "#f3f4f6", color: "#6b7280" },
};

export default function PriorityBadge({ priority }) {
  const style = COLORS[priority] || COLORS.low;
  return (
    <span className="badge" style={{ background: style.bg, color: style.color }}>
      {priority}
    </span>
  );
}
